export default "__VITE_ASSET__85cc8670__"